export const minor_league = [
  {
    number: 'ML100',
    hasModel: false
  },
  {
    number: 'ML101',
    hasModel: false
  },
  {
    number: 'ML102',
    hasModel: false
  },
  {
    number: 'ML103',
    hasModel: false
  },
  {
    number: 'ML104',
    hasModel: false
  },
  {
    number: 'ML105',
    hasModel: false
  },
  {
    number: 'ML106',
    hasModel: false
  },
  {
    number: 'ML107',
    hasModel: false
  },
  {
    number: 'ML108',
    hasModel: false
  },
  {
    number: 'ML109',
    hasModel: false
  },
  {
    number: 'ML110',
    hasModel: false
  },
  {
    number: 'ML111',
    hasModel: false
  },

]